import { render } from "./vs-input.vue?vue&type=template&id=49dfb62c&scoped=true&ts=true"
import script from "./vs-input.vue?vue&type=script&lang=ts"
export * from "./vs-input.vue?vue&type=script&lang=ts"

import "./vs-input.vue?vue&type=style&index=0&id=49dfb62c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49dfb62c"]])

export default __exports__